<template>
  <div class="page__wrapper" @scroll="onScroll()">
    <FCBenefits :h2="this.h2" :h3="this.h3" :benefits="this.benefits" />
  </div>
</template>

<script>
import FCBenefits from "@/components/patterns/FCBenefits";
export default {
  components: {
    FCBenefits
  },
  data() {
    return {
      h2: "Pitch View Club",
      h3: "Benefits",
      benefits: [
        {
          icon: "chair.png",
          text: `Padded club seats positioned at midline and perched at the optimal viewing angle`
        },
        {
          icon: "plate.png",
          text: `All-inclusive: Upscale cuisine and top-shelf beverage selection included with ticket`
        },
        {
          icon: "car.png",
          text: `Reserved parking on site`
        },
        {
          icon: "window.png",
          text: `Floor to ceiling glass for great viewing from inside or out`
        },
        {
          icon: "club.png",
          text: `Private indoor club; with additional access to the Cincinnatus Club`
        },
        {
          icon: "veranda.png",
          text: `Outdoor veranda with seating for gathering and watching`
        }
      ]
    };
  },
  mounted() {
    const ref = this.$store.state.menu.pitchView.ref;
    const index = this.$store.state.menu.menuItems.map(e => e.ref).indexOf(ref);
    this.$store.state.menu.activeSection = index;
    this.$store.state.menu.currentSectionTitle = this.$store.state.menu.pitchView.title;
    this.$store.state.menu.currentSectionNavigation = this.$store.state.menu.pitchView.nav;
    this.onScroll();
  }
};
</script>

<style lang="scss" scoped>
.page__wrapper {
  background-image: url("~@/assets/backgrounds/bg-pitch-intro.jpg");
  background-size: cover;
  background-position: center;
}
</style>